<div [class]="'achievement-card ' + cardClass">
  <div class="row no-gutters achievement">
    <div class="achievement-item col-12">
      <div class="d-flex">
        <i class="achievement-icon fas fa-check"></i>
        <div>
          <div>{{ achievement.i18next_name | i18next }}</div>
          @if (descriptionContent !== '') {
            <div class="small">{{ descriptionContent }}</div>
          }
        </div>
        <div>&nbsp;</div>
        @if (helpContent !== '') {
          <i
             class="ml-auto far fa-question-circle achievement-tooltip"
             [pTooltip]="helpContent"
             [tooltipEvent]="deviceService.tooltipEvent" tabindex="0"></i>
        }
      </div>

    </div>
  </div>
</div>
